/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerShoppingCartBookListBookCartDto from './CustomerShoppingCartBookListBookCartDto';
import CustomerShoppingCartBookListDto from './CustomerShoppingCartBookListDto';

/**
 * The CustomerShoppingCartDto model module.
 * @module model/CustomerShoppingCartDto
 * @version v1.0.0
 */
class CustomerShoppingCartDto {
    /**
     * Constructs a new <code>CustomerShoppingCartDto</code>.
     * @alias module:model/CustomerShoppingCartDto
     */
    constructor() { 
        
        CustomerShoppingCartDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomerShoppingCartDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomerShoppingCartDto} obj Optional instance to populate.
     * @return {module:model/CustomerShoppingCartDto} The populated <code>CustomerShoppingCartDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomerShoppingCartDto();

            if (data.hasOwnProperty('bookList')) {
                obj['bookList'] = ApiClient.convertToType(data['bookList'], [CustomerShoppingCartBookListDto]);
            }
            if (data.hasOwnProperty('cart')) {
                obj['cart'] = ApiClient.convertToType(data['cart'], [CustomerShoppingCartBookListBookCartDto]);
            }
            if (data.hasOwnProperty('purchaseMissionId')) {
                obj['purchaseMissionId'] = ApiClient.convertToType(data['purchaseMissionId'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/CustomerShoppingCartBookListDto>} bookList
 */
CustomerShoppingCartDto.prototype['bookList'] = undefined;

/**
 * @member {Array.<module:model/CustomerShoppingCartBookListBookCartDto>} cart
 */
CustomerShoppingCartDto.prototype['cart'] = undefined;

/**
 * @member {Number} purchaseMissionId
 */
CustomerShoppingCartDto.prototype['purchaseMissionId'] = undefined;

/**
 * @member {String} title
 */
CustomerShoppingCartDto.prototype['title'] = undefined;






export default CustomerShoppingCartDto;

